module.exports = __webpack_public_path__ + "img/fi-rr-text-check.569f8b95.svg";